import {AbstractControl, FormControl, ValidatorFn} from "@angular/forms";

export function validateLongitude(control: FormControl): { [key: string]: any } {

  let maxLongitude = 180;
  let minLongitude = -180;

  return validateCoordinate(control, minLongitude, maxLongitude) ? {'validLongitude': true} : null;
}

export function validateLatitude(control: FormControl): { [key: string]: any } {

  let maxLatitude = 85.051128;
  let minLatitude = -85.051128;

  return validateCoordinate(control, minLatitude, maxLatitude) ? {'validLatitude': true} : null;
}

function validateCoordinate(control: FormControl, minValue: number, maxValue: number): boolean {
  let COORDINATE_REGEXP = /(-?\d+(.\d+)?)/;

  if (control.value != null) {
    return (!COORDINATE_REGEXP.test(control.value) || control.value < minValue || control.value > maxValue);
  } else {
    return null;
  }
}

export function validateZoom(control: FormControl): { [key: string]: any } {

  if (control.value != null && (control.value <= 0 || control.value > 18)) {
    return {'validZoom': true};
  } else {
    return null;
  }

}

export function validateEmail(control: FormControl): { [key: string]: any } {

  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  if (control.value != null) {
    return !EMAIL_REGEXP.test(control.value) ? {'validEmail': true} : null;
  } else {
    return null;
  }

}

export function validateOptionalEmail(control: FormControl): { [key: string]: any } {
  let value: string = control.value;
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  return (value !== null && value !== undefined && value !== '' && !EMAIL_REGEXP.test(control.value))
    ? {'validEmail': true} : null;
}


export function validateUniqueId(control: FormControl): { [key: string]: any } {

  let UNIQUEID_REGEX = /^\w*$/;

  if (control.value != null) {
    return !UNIQUEID_REGEX.test(control.value) ? {'validUniqueId': true} : null;
  } else {
    return null;
  }

}

export function validateOrgByType(typeOrganizaton: any): ValidatorFn {

  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (typeOrganizaton.value !== 5
      && control.value === null) {
      return {'organizationSup': true};
    }
    return null;
  };
}

export function validateMatch(word: string): ValidatorFn {
  return (control: FormControl): { [key: string]: boolean } => {
    let value: string = control.value;
    return value !== word ? {"uniqueIdMatch": true} : null;
  };
}

export function validatePassword(): ValidatorFn {
  return (control: FormControl): { [key: string]: boolean } => {
    const value: string = control.value;
    return (value.length < 4 || value.indexOf(' ') !== -1) ? {'incorrectpassword': true} : null;
  };
}

